import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError, thrownResponse } from "axios_config";
import { IGeomatic, IGetOptions, ISetClientToken } from "./interface";

export const useGetGeomatic = (options?: IGetOptions) => {
  return useQuery<IGeomatic | any, AxiosError>(["get-all-data-geomantic-storm", options], async () => {
    const res = await axios.get(`/get-all-data-geomantic-storm`, options);
    if (res.status >= 200 && res.status < 300 && res.data?.result) {
      const { result } = res.data;
      if (result[0]) {
        return result[0];
      }
      thrownResponse(res);
    } else {
      thrownResponse(res);
    }
  });
};

export const useSetClientToken = (options?: ISetClientToken) => {
  return useQuery<any, AxiosError>(["set-client-token", options], async () => {
    if (options?.token !== "" && typeof options?.token !== "undefined") {
      const res = await axios.get(`/get-data-token`, { params: options });
      if (res.status >= 200 && res.status < 300) {
        return res.data;
      } else {
        thrownResponse(res);
      }
    } else {
      return null;
    }
  });
};
